import React, { Component } from 'react';
import { Breadcrumb, Tabs, Button, Form, Input, Radio, DatePicker, message, Select, Modal } from 'antd';
import { Link } from "react-router-dom";
import './index.less';
import ImgPreview from 'CMPT/common/ImgPreview';
import UploadVoucher from './uploadVoucher';
import { API } from '@/http/api';
import http from '@/http';
import userUtil from "@/utils/user";
import moment from "moment";
import debounce from 'lodash/debounce';
import Table from "CMPT/common/Table";
const { RangePicker } = DatePicker;
const BreadcrumbItem = Breadcrumb.Item;
const { TabPane } = Tabs;
const { Search, TextArea } = Input;

const Option = Select.Option
const RadioGroup = Radio.Group
class UserOrder extends Component {

    state = {
        searchValue: '',
        companyName: '',
        columns: [
            {
                title: "姓名",
                key: "userName",
                align: "center",
                dataIndex: "userName",
            },
            {
                title: "手机号码",
                key: "mobile",
                align: "center",
                dataIndex: "mobile",
            },
            {
                title: "企业名称",
                key: "organizationName",
                align: "center",
                dataIndex: "organizationName",
                
            },
            {
                title: "充值总金额", 
                key: "totalAmount",
                align: "center",
                dataIndex: "totalAmount",
            },{
                title: "充值总次数", 
                key: "totalNumber",
                align: "center",
                dataIndex: "totalNumber",
            },
            {
                title: "已使用次数", 
                key: "usedNumber",
                align: "center",
                dataIndex: "usedNumber",
            },
            {
                title: "剩余次数", 
                key: "balanceNumber",
                align: "center",
                dataIndex: "balanceNumber",
            },
            {
                title: "用户状态", 
                key: "statusName",
                align: "center",
                dataIndex: "statusName",
                render: (text, record) => {
                    return (
                        <span>{text == 0 ? '禁用' : "启用"}</span>
                    );
                },
            },
            {
                title: "更新时间", 
                key: "editDate",
                align: "center",
                dataIndex: "editDate",
                render: (text, record) => {
                    return (
                        <span>{text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"}</span>
                    );
                },
            },
        ],
        params: {
            pageSize: 10,
            pageNo: 1,
        },
        addRecordList: [],
        currentIndex: 0,
        payMoneyVoucherModal: false,
        upVCode: '',
        sourceList: [],
        supplierArray: [
            {
                key: 0,
                value: "禁用"
            },
            {
                key: 1,
                value: "启用"
            },
        ],
    }

    componentDidMount() {
        this.auditList()
        // this.getSourceList()
    }

    auditDepositModal = (auditStatus, code) => {
        if (auditStatus == '10') {
            Modal.confirm({
                title: '提示',
                icon: 'none',
                content: <div className='confirm_text'>
                    <div className='confirm_1'>确定已收到款吗？</div>
                    <div className='confirm_2'>说明：确定后将自动为该用户充值</div>
                </div>,
                onOk: () => {
                    this.auditDeposit(code, auditStatus)
                }
            })
        } else {
            Modal.confirm({
                title: '提示',
                icon: 'none',
                content: <div>
                    <TextArea
                        rows={4}
                        onChange={this.onRejectInput}
                        placeholder="请输入驳回理由 （100字以内）"
                        maxLength={100}
                    />
                    <span>说明：驳回后用户可重新发起订单付款</span>
                </div>,
                onOk: () => {
                    this.auditDeposit(code, auditStatus)
                }
            })
        }
    }
    onRejectInput = (e) => {
        this.state.auditRemark = e.target.value;
    };

    goRecord = (code) => {
        this.props.history.push(`/app/crm/valueaddService/trajectoryFind/operaterRecord/${code}`)
    }

    auditDeposit = (code, auditStatus) => {
        const config = {
            api: API.valueAddServiceAuditDeposit,
            showLoading: true,
            data: {
                code,
                auditStatus
            }
        };
        let { auditRemark } = this.state;
        if (auditStatus == '20') {
            config.data.auditRemark = auditRemark;
        }
        http(config).then(res => {
            if (res.code == 200) {
                message.success('操作成功')
                this.auditList()
            }
        })
    }

    getSourceList = () => {
        const config = {
            api: API.valueAddServiceGetSourceList,
            showLoading: true,
        };
        http(config).then(res => {
            if (res.code == 200) {
                this.setState({
                    sourceList: res.data
                })
            }
        })
    }

    imgShow = (list) => {
        let imgList = list.map(item => {
            return item.url
        })
        this.setState({
            imgList,
            previewVisible: true
        })
    }
    closeImagePreview = () => {
        this.setState({
            previewVisible: false
        })
    }


    auditList = () => {
        let { params } = this.state;
        const config = {
            api: API.valueAddServiceUserTrackBalanceList,
            showLoading: true,
            data: params
        };
        http(config).then(res => {
            if (res.code == 200) {
                res.result.total = Number(res.result.total)
                this.setState({
                    addRecordList: res.result
                })
            }
        })
    }

    rangeChange = (value, date) => {
        let params = this.state.params;
        params.startDate = date[0];
        params.endDate = date[1];
        this.setState({
            params,
            startDate: value[0],
            endDate: value[1]
        }, () => {
            this.auditList();
        })
    }

    changeSource = (e) => {
        let params = this.state.params;
        params.tenantCode = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }

    changeSupplier = (e) => {
        let params = this.state.params;
        params.status = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    queryStatusSearch = (e) => {
        let params = this.state.params;
        params.status = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    changetrackQueryType = (e) => {
        let params = this.state.params;
        params.trackQueryType = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    trackQueryTypeSearch = (e) => {
        console.log(e);
        let params = this.state.params;
        params.trackQueryType = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }
    searchChange = (e) => {
        this.setState({
            searchValue: e.target.value
        })
    }
    onSearchOn = (e) => {
        let { params } = this.state;
        params.keyword = e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }
    companyNameChange = (e) => {
        this.setState({
            companyName: e.target.value
        })
    }
    onCompanyNameOn = (e) => {
        let { params } = this.state;
        params.companyName = e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }


    resetSearch = () => {
        let { params } = this.state;
        params.keyword = '';
        params.startDate = '';
        params.endDate = '';
        params.tenantCode = undefined;
        params.status = undefined;
        params.trackQueryType = undefined;

        this.setState({
            params,
            startDate: undefined,
            endDate: undefined,
            searchValue: '',
            companyName: '',
        }, () => {
            this.auditList()
        })
    }

    payMoneyVoucherModalOk = (payPhotos) => {
        console.log(payPhotos, 'payPhotos');
        let { upVCode } = this.state;
        const config = {
            api: API.valueAddServiceDepositUpload,
            showLoading: true,
            data: {
                code: upVCode,
                payPhotos
            }
        };
        http(config).then(res => {
            if (res.code == 200) {
                message.success('上传成功');
                this.setState({
                    payMoneyVoucherModal: false
                })
                this.auditList()
            }
        })
    }

    payMoneyVoucherModalCancel = () => {
        this.setState({
            payMoneyVoucherModal: false
        })
    }

    //分页
    onChangePage = (pageNo, pageSize, sort) => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    pageNo: pageNo,
                    pageSize: pageSize,
                },
            },
            () => {
                this.auditList();
            }
        );
    };


    render() {
        const { searchValue, companyName, params, addRecordList, columns, previewVisible, currentIndex, imgList, startDate, endDate, payMoneyVoucherModal, sourceList, supplierArray, trackQueryArray } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (

            <div className="enterprise-auth-con-1">
                {/* <div className='enterprise-auth-header'>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link
                                style={{ color: "#333" }}
                                to={{
                                    pathname: "/app/crm/valueaddService/trajectoryFind",
                                }}
                            >
                                数据概览
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>添加记录</Breadcrumb.Item>
                    </Breadcrumb>
                </div> */}
                <div className='tab_box'>
                    {/* <Tabs defaultActiveKey="0" className='tabs' style={{margin: 0}} onChange={this.changeTabs} >
                        <TabPane tab="全部"  key="0" className='tab'>
                        </TabPane>
                        <TabPane tab="待审批"  key="1" className='tab'>
                        </TabPane>
                        <TabPane tab="已成功"  key="2" className='tab'>
                        </TabPane>
                        <TabPane tab="账期待付款"  key="4" className='tab'>
                        </TabPane>
                        <TabPane tab="已失败"  key="3" className='tab'>
                        </TabPane>
                    </Tabs> */}

                    <div className='table_box' style={{ paddingTop: '24px' }}>
                        <div className="goods_fliter">
                            
                            <Select allowClear showSearch optionFilterProp="label" value={params.status} onChange={this.changeSupplier} onSearch={this.queryStatusSearch}
                                placeholder="用户状态" style={{ width: '100px', display: 'inline-block' }}>
                                {supplierArray.map(item => (
                                    <Option key={item.key} value={item.key} label={item.value}>
                                        <span>{item.value}</span>
                                    </Option>
                                ))}
                            </Select>
                            <Search
                                placeholder="姓名/手机号码/企业名称"
                                enterButton="搜索"
                                className="goods_search nomargin"
                                value={searchValue}
                                // size="large"
                                onChange={value => { this.searchChange(value) }}
                                onSearch={value => { this.onSearchOn(value) }}
                            />
                            <span className="goods_reset" onClick={this.resetSearch}>重置</span>
                        </div>
                        <Table
                            columns={columns}
                            selfProcessData={addRecordList && addRecordList.records}
                            total={addRecordList && addRecordList.total}
                            change={this.onChangePage}
                            current={addRecordList && addRecordList.current}
                        />
                    </div>
                </div>

            </div>

        );
    }
}

const UserTOrder = Form.create({ name: "UserOrder" })(UserOrder);
export default UserTOrder;